import React, { useCallback, useEffect, useState } from 'react';

import * as selectedStoreStorage from '../lib/storage/selectedStore';

type SelectedStore = selectedStoreStorage.SelectedStore;

type SelectedStoreContextProps = {
  // SelectedStore defines the user's selected store
  selectedStore: SelectedStore | null;
  // setSelectedStore sets a new selected store in context and stores it in local storage
  setSelectedStore: (store: SelectedStore) => void;
  // removeSelectedStore removes the selected store from context and local storage
  removeSelectedStore: () => void;
};

const SelectedStoreContext =
  React.createContext<SelectedStoreContextProps | null>(null);

/**
 * SelectedStoreContextProvider provides the selectedstore context to it's children
 */
export function SelectedStoreContextProvider({
  children,
}: React.PropsWithChildren<{}>) {
  const [selectedStore, setSelectedStoreState] = useState(
    selectedStoreStorage.get()
  );

  // Persist the token to local storage when the token changes. Remove the token
  // if it is null.
  useEffect(() => {
    if (selectedStore) {
      selectedStoreStorage.set(selectedStore);
    } else {
      selectedStoreStorage.remove();
    }
  }, [selectedStore]);

  const removeSelectedStore = useCallback(() => {
    setSelectedStoreState(null);
  }, []);

  const setSelectedStore = useCallback((s) => {
    setSelectedStoreState(s);
  }, []);

  const ctx = {
    selectedStore,
    setSelectedStore,
    removeSelectedStore,
  };

  return (
    <SelectedStoreContext.Provider value={ctx}>
      {children}
    </SelectedStoreContext.Provider>
  );
}

export default SelectedStoreContext;
